const CONTROL_SELECTOR = [
  'button',
  'a',
  'input',
  'select',
  'textarea',
  'summary',
  'app-filter-multi-select',
  'app-filter-date-range',
  'app-filter-polygon-plan-status',
  'app-chart-range-controls',
].join(', ');

/** First on-screen element for a `data-guide` value. Empty chrome is skipped. */
export function findGuideTarget(target: string): HTMLElement | null {
  if (typeof document === 'undefined') return null;
  const nodes = document.querySelectorAll<HTMLElement>(`[data-guide="${CSS.escape(target)}"]`);
  for (const el of Array.from(nodes)) {
    if (isGuideTargetVisible(el)) return el;
  }
  return null;
}

function isGuideTargetVisible(el: HTMLElement): boolean {
  if (!el.isConnected) return false;
  const style = getComputedStyle(el);
  if (style.display === 'none' || style.visibility === 'hidden') return false;
  const rect = el.getBoundingClientRect();
  if (rect.width < 8 || rect.height < 8) return false;
  if (el.getAttribute('data-guide-optional') === 'empty' && !hasVisibleControl(el)) return false;
  return true;
}

function hasVisibleControl(root: HTMLElement): boolean {
  const nodes = root.querySelectorAll<HTMLElement>(CONTROL_SELECTOR);
  for (const node of Array.from(nodes)) {
    const style = getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden') continue;
    const rect = node.getBoundingClientRect();
    if (rect.width >= 8 && rect.height >= 8) return true;
  }
  return false;
}

/** Bring the target into the scrollport without animation (overlay motion is separate). */
export function scrollGuideTargetIntoView(el: HTMLElement): void {
  const rect = el.getBoundingClientRect();
  const vh = window.innerHeight;
  const visible = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
  const wanted = Math.min(rect.height, vh);
  if (wanted > 0 && visible > wanted * 0.6) return;
  const tall = rect.height > vh * 0.65;
  el.scrollIntoView({ block: tall ? 'start' : 'nearest', inline: 'nearest', behavior: 'auto' });
}
